<template>
    <!--    <div class="nong-publications-div" @wheel.prevent="mouseWheel">-->
    <div class="nong-publications-div">
        <div class="nong-box-cover"></div>
        <div class="nong-publications-title">
            {{ $t('message.publication') }}
        </div>
        <div class="nong-publications-box">
            <div class="nong-publications-box-button nong-publications-margin-top">
                <img class="nong-works-arrow" v-show="page!=0" src="../../assets/image/arrow-t-l.png" @click="arrowT">
            </div>
            <div :class="['nong-publications-boxs',isIosShow?'nong-bottom':'']">
                <v-row v-if="img.length>0" class="nong-publications-imgs">
                    <v-col v-for="(list,i) in img[page].data" :key="i" cols="6"
                           md="2"
                           lg="2"
                           xl="2">
                        <!--                        <router-link to='/publications/details'>-->
                        <div style="cursor: pointer" @click="detail(list.id)">
                            <p-list :imgSrc="list"></p-list>
                        </div>
                        <!--                        </router-link>-->
                    </v-col>
                </v-row>
                <v-row v-if="img.length>0" class="nong-publications-imgs-h5">
                    <v-col v-for="(imglist,i) in imgList" :key="i" cols="6"
                           md="2"
                           lg="2"
                           xl="2">
                        <!--                        <router-link to='/publications/details'>-->
                        <div style="cursor: pointer" @click="detail(imglist.id)">
                            <p-list :imgSrc="imglist"></p-list>
                        </div>
                        <!--                        </router-link>-->
                    </v-col>
                </v-row>
                <!--                <div class="nong-publications-boxs-seoll"></div>-->
            </div>
            <div class="nong-publications-box-button nong-publications-margin-botton">
                <img class="nong-works-arrow" v-show="page>=0&&page!=img.length-1"
                     src="../../assets/image/arrow-b-l.png" @click="arrowB">
            </div>
        </div>
    </div>
</template>

<script>
import pList from "../../components/publicationList";
import {webPublicationList} from "../../api/home";

export default {
  name: "publications",
  components: {
    pList
  },
  data() {
    return {
      isIosShow:false,
      img: [],
      page: 0,
      imgList: []
    }
  },
  mounted() {

  },
  created() {
    this.initData()
    window.addEventListener('scroll', this.handleScroll, true);
    let u = navigator.userAgent;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
      this.isIosShow = true
    } else {
      this.isIosShow = false
    }
  },
  methods: {
    detail(id) {
      this.$router.push({
        path: '/publications/details',
        query: {
          id: id,
        }
      })
    },
    initData() {
      webPublicationList().then(res => {
        // window.console.log(localStorage.getItem('locale'))
        if (res.errcode == 0) {
          window.console.log(res.data)
          let list = res.data
          for (let i = 0; i < list.length; i++) {
            list[i].pic = this.$ctx + list[i].pic
          }
          this.imgList = list
          this.sort(list)
          // this.imgList=list
        } else {
          window.console.log(res)
        }
      }).catch(err => {
        window.console.log(err)
      });
    },
    sort(imgs) {
      let objList = new Object();
      let arr = new Array();
      let size = imgs.length / 12 == 0 ? imgs.length / 12 : Math.ceil((imgs.length / 12));
      // window.console.log('行数', size);
      for (let i = 1; i <= size; i++) {
        let tempArr = [];
        let temp;
        if (12 * i > imgs.length) {
          temp = imgs.length;
        } else {
          temp = 12 * i;
        }
        for (let j = 12 * (i - 1); j < temp; j++) {
          tempArr.push(imgs[j]);
        }
        let newObj = new Object();
        newObj.data = tempArr
        arr.push(newObj);
      }
      objList.data = arr;
      this.img = objList.data
      // window.console.log(objList)
    },
    arrowT() {
      this.page = this.page - 1
    },
    arrowB() {
      // window.console.log(this.page)
      this.page = this.page + 1
    },
    // mouseWheel(e) {
    //   e = e || window.event;
    //   if (e.wheelDelta) {  //判断浏览器IE，谷歌滑轮事件
    //     if (e.wheelDelta > 0) { //当滑轮向上滚动时
    //       // alert("滑轮向上滚动");
    //       if(this.page!=0){
    //         this.arrowT()
    //       }
    //     }
    //     if (e.wheelDelta < 0) { //当滑轮向下滚动时
    //       // alert("滑轮向下滚动");
    //       if (this.page >= 0 && this.page != this.img.length - 1) {
    //         this.arrowB()
    //       }
    //     }
    //   } else if (e.detail) {  //Firefox滑轮事件
    //     if (e.detail > 0) { //当滑轮向上滚动时
    //       // alert("滑轮向上滚动");
    //       if(this.page!=0){
    //         this.arrowT()
    //       }
    //     }
    //     if (e.detail < 0) { //当滑轮向下滚动时
    //       // alert("滑轮向下滚动");
    //       if (this.page >= 0 && this.page != this.img.length - 1) {
    //         this.arrowB()
    //       }
    //     }
    //   }
    // }
  },
}
</script>

<style scoped>
    @media screen and (min-width: 960px) {
        .nong-publications-div {
            width: 100%;
            height: 100%;
            padding-top: 100px;
            box-sizing: border-box;
        }

        .nong-publications-title {
            width: 100%;
            height: 100px;
            position: absolute;
            top: 0;
            color: white;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            font-size: 25px;
            padding-top: 60px;
        }

        .nong-publications-box {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            /*overflow-y: auto;*/
        }

        .nong-publications-box-button {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .nong-publications-box-button img {
            width: 30px;
            /*margin: 20px;*/
        }

        .nong-publications-margin-top {
            margin-top: 35px;
        }

        .nong-publications-margin-botton {
            margin-bottom: 35px;
        }

        .nong-publications-boxs {
            width: 70%;
            /*height: 500px;*/
            display: flex;
            align-content: space-between;
            justify-content: center;
        }

        .nong-publications-imgs {
            padding: 22px;
        }

        .nong-publications-imgs-h5 {
            display: none;
        }

        .nong-works-arrow {
            animation-fill-mode: both; /*播放后的状态*/
            animation-iteration-count: infinite; /*动作循环的次数：infinite 无限循环*/
            animation-duration: 4s; /*动画时间*/
            animation-name: container;
            cursor: pointer;
        }

        @keyframes container {
            0% {
                opacity: 0.2;
            }
            50% {
                /*transition-timing-function: cubic-bezier(0.755,0.50,0.855,0.060);*/
                /*transform: translate3d(0,-15px,0);*/
                opacity: 1;
            }
            100% {
                /*transform: translate3d(0,0px,0);*/
                opacity: 0.2;
            }
        }
    }

    @media screen and (max-width: 960px) {
        .nong-publications-div {
            width: 100%;
            height: 100%;
        }

        .nong-publications-title {
            width: 100%;
            height: 100px;
            /*position: absolute;*/
            /*top: 0;*/
            color: white;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            font-size: 20px;
            padding-top: 60px;
            margin-bottom: 10px;
        }

        .nong-publications-box-button {
            display: none;
        }

        .nong-publications-box {
            width: 100%;
            height: 100%;
        }

        .nong-publications-boxs {
            /*width: 70%;*/
            /*height: 500px;*/
            box-sizing: border-box;
            padding: 0 25px;
        }

        .nong-publications-imgs {
            display: none;
        }

        .nong-publications-imgs-h5 {
            padding: 20px 25px;
        }

        .nong-box-cover {
            width: 98%;
            height: 60px;
            position: absolute;
            background-color: black;
            top: 0;
            left: 0;
            z-index: 1;
        }

        .nong-bottom {
            padding-bottom: 60px;
        }
    }

</style>
